<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRouter, RouterLink } from 'vue-router'
import employeeApis from '@/services/backend/employee'
import storageService from '@/services/storage'
import appLayoutUtils from '@/utils/app-layout'
import EgoLogo from '@/assets/ego-logo.png'
import type { Ref } from 'vue'

const router = useRouter()

const openMenu: Ref<boolean> = ref(false) // this flag used when screen is small to toggle open and close bootstrap nav
const searchTerm: Ref<string> = ref('')
const navBarItems: Ref<{ value: string; routeName: string }[]> = ref([])

onMounted(async () => {
  if (storageService.isSignedIn()) {
    if (storageService.getRole() === 'employee') {
      const response = await employeeApis.get(storageService.getUserId()!)
      if (response.isSuccess) {
        navBarItems.value = appLayoutUtils.getUserNavbarItems({
          role: 'employee',
          data: response.data
        })
      }
    } else {
      navBarItems.value = appLayoutUtils.getUserNavbarItems({ role: 'admin' })
    }
  }
})

function goToSearchPage() {
  router.push({
    name: 'SearchResults',
    query: { term: searchTerm.value }
  })
}
</script>

<template>
  <div class="bg-light" style="min-height: 100vh">
    <nav v-if="storageService.isSignedIn()" class="navbar navbar-expand-lg bg-dark-subtle">
      <div class="container-fluid">
        <a class="navbar-brand" href="/"> <img :src="EgoLogo" alt="logo" style="width: 125px" /></a>
        <button class="navbar-toggler" type="button" @click="openMenu = !openMenu">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div
          id="navbarSupportedContent"
          class="collapse navbar-collapse"
          :class="{ show: openMenu }"
        >
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li v-for="item in navBarItems" :key="item.routeName" class="nav-item">
              <router-link :to="{ name: item.routeName }" class="nav-link">{{
                item.value
              }}</router-link>
            </li>
            <li class="nav-item" @click="storageService.signOut">
              <button class="nav-link">Logout</button>
            </li>
          </ul>
          <form class="d-flex" role="search" @submit.prevent>
            <input
              v-model="searchTerm"
              class="form-control me-2"
              type="search"
              placeholder=""
              aria-label="Search"
              @keypress.enter="goToSearchPage"
            />
            <button class="btn btn-outline-success" type="button" @click="goToSearchPage">
              Search
            </button>
          </form>
        </div>
      </div>
    </nav>
    <div class="py-3">
      <router-view />
    </div>
  </div>
</template>

<style></style>
